import { useContext, useState } from "react"

import RequestService from "../../../services/RequestService";
import { StateRequest } from "../../../views/Pages/Coms/Com/Home/Home";
import { ARCHIVED_REASONS_LABELS } from "../../../utils/ArchivedReasonsUtils";
import Select from "../../Atomes/Select/Select";

const MAX_CUSTOM_REASON_LENGTH = 200;

const PopUpArchiveFile = ({ idProject, reference, onClickNo }) => {
	const { stateRequest, setStateRequest } = useContext(StateRequest);

	const reasonCodes = Object.keys(ARCHIVED_REASONS_LABELS);
	const reasonLabels = Object.values(ARCHIVED_REASONS_LABELS);
	const selectOptions = ["Sélectionnez une raison", ...reasonLabels];
	const selectValues = ["", ...reasonCodes];

	const [selectedReason, setSelectedReason] = useState("");
	const [customReason, setCustomReason] = useState("");

	const isOtherSelected = selectedReason === "other";
	const customReasonValid = customReason.trim().length > 0 && customReason.length <= MAX_CUSTOM_REASON_LENGTH;
	const canSubmit =
		selectedReason !== "" &&
		(selectedReason !== "other" || customReasonValid);

	const archiveFile = async () => {
		if (!canSubmit) return;
		const reason =
			selectedReason === "other" ? customReason.trim() : selectedReason;
		const request = await RequestService.reopenFileArchived(idProject, {
			status: "archived",
			reason,
		});
		onClickNo();
		if (request.request.status === 200) {
			setStateRequest("success archive");
		} else {
			setStateRequest("error");
		}
	};

	return (
		<div className={"pop-up-base-style active"}>
			<div className={"pop-up-user-delete"}>
				<img
					onClick={onClickNo}
					className={"cross-close"}
					src={"/images/pictos/cross-close.svg"}
					alt={"fermer la pop up"}
				/>
				<img src={"/images/medias/popup.svg"} alt="test" />
				<h4>Êtes-vous sûr de vouloir archiver le projet {reference} ?</h4>

				<div className={"pop-up-archive-reason"} style={{ marginBottom: "44px", gap: "10px", display: "flex", flexDirection: "column" }}>
					<label>Raison d'archivage (obligatoire)</label>
					<Select
						styleSelect={"select-custom-secondary"}
						data={selectOptions}
						value={selectValues}
						onChange={(e) => setSelectedReason(e.target.value)}
						selectedValue={selectedReason}
						showDefaultOption={false}
					/>
					{isOtherSelected && (
						<div className={"pop-up-archive-custom-reason"} style={{ gap: "10px", display: "flex", flexDirection: "column" }}>
							<label htmlFor="archive-reason-custom">Précisez la raison (max. {MAX_CUSTOM_REASON_LENGTH} caractères)</label>
							<input
								id="archive-reason-custom"
								type="text"
								className={"form-control"}
								placeholder={"Saisissez la raison d'archivage"}
								value={customReason}
								onChange={(e) => setCustomReason(e.target.value.slice(0, MAX_CUSTOM_REASON_LENGTH))}
								maxLength={MAX_CUSTOM_REASON_LENGTH}
							/>
							<small style={{ color: "var(--color-secondary, #6c757d)" }}>
								{customReason.length} / {MAX_CUSTOM_REASON_LENGTH} caractères
							</small>
						</div>
					)}
				</div>

				<div className={"pop-up-user-delete-buttons"}>
					<button className={"btn btn-cancel"} onClick={onClickNo}>
						Non
					</button>
					<button
						className={"btn btn-primary"}
						onClick={() => archiveFile()}
						disabled={!canSubmit}
					>
						Oui
					</button>
				</div>
			</div>
		</div>
	);
};

export default PopUpArchiveFile;